// import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React from "react";

// import Login from "./component/login/Login";
import Login from "./component/login/LoginUser";
import Home from "./component/home/Home";
import User from "./component/user/User";
import UserAdd from "./component/user/UserAdd";
import UserEdit from "./component/user/UserEdit";
import Blog from "./component/blog/Blog";
import BlogAdd from "./component/blog/BlogAdd";
import BlogEdit from "./component/blog/BlogEdit";
import BlogGroup from "./component/blog_group/Blog_Group";
import BlogGroupAdd from "./component/blog_group/Blog_GroupAdd";
import BlogGroupEdit from "./component/blog_group/Blog_GroupEdit";
import Faq from "./component/faq/Faq";
import FaqAdd from "./component/faq/FaqAdd";
import FaqEdit from "./component/faq/FaqEdit";
import Program from "./component/program/Program";
import ProgramAdd from "./component/program/ProgramAdd";
import ProgramEdit from "./component/program/ProgramEdit";
import ProgramGroup from "./component/program_group/ProgramGroup";
import ProgramGroupAdd from "./component/program_group/ProgramGroupAdd";
import ProgramGroupEdit from "./component/program_group/ProgramGroupEdit";
import InfoCompany from "./component/info_company/InfoCompany";
import InfoCompanyAdd from "./component/info_company/InfoCompanyAdd";
import InfoCompanyEdit from "./component/info_company/InfoCompanyEdit";
import Struktur from "./component/struktur/Struktur";
import StrukturAdd from "./component/struktur/StrukturAdd";
import StrukturEdit from "./component/struktur/StrukturEdit";
import Jejak from "./component/jejak_langkah/JejakLangkah";
import JejakAdd from "./component/jejak_langkah/JejakLangkahAdd";
import JejakEdit from "./component/jejak_langkah/JejakLangkahEdit";
import Galeri from "./component/galeri/Galeri";
import GaleriAdd from "./component/galeri/GaleriAdd";
import GaleriEdit from "./component/galeri/GaleriEdit";
import GaleriGroup from "./component/galeri_group/Galeri_Group";
import GaleriGroupAdd from "./component/galeri_group/Galeri_GroupAdd";
import GaleriGroupEdit from "./component/galeri_group/Galeri_GroupEdit";
import PublicRoute from "./component/protect/PublicRoute";
import ProtectedRoute from "./component/protect/ProtectedRoute";
import Recruit from "./component/recruit/Recruit";
import RecruitAdd from "./component/recruit/RecruitAdd";
import RecruitEdit from "./component/recruit/RecruitEdit";
import Berkarir from "./component/berkarir_ykbut/Career";
import BerkarirAdd from "./component/berkarir_ykbut/CareerAdd";
import BerkarirEdit from "./component/berkarir_ykbut/CareerEdit";
import Entitas from "./component/sustainbility/Entitas";
import EntitasAdd from "./component/sustainbility/EntitasAdd";
import EntitasEdit from "./component/sustainbility/EntitasEdit";
import Pelaporan from "./component/sistem_laporan/Pelaporan";
import PelaporanAdd from "./component/sistem_laporan/PelaporanAdd";
import PelaporanEdit from "./component/sistem_laporan/PelaporanEdit";
import Dcare from "./component/dcare/Dcare";
import DcareAdd from "./component/dcare/DcareAdd";
import DcareEdit from "./component/dcare/DcareEdit";
import Utschool from "./component/utschoolz/Utschool";
import UtschoolAdd from "./component/utschoolz/UtschoolAdd";
import UtschoolEdit from "./component/utschoolz/UtschoolEdit";
import Poliklinik from "./component/poliklinik/Poliklinik";
import PoliklinikAdd from "./component/poliklinik/PoliklinikAdd";
import PoliklinikEdit from "./component/poliklinik/PoliklinikEdit";
import Kontak from "./component/kontak/Kontak";
import KontakAdd from "./component/kontak/KontakAdd";
import KontakEdit from "./component/kontak/KontakEdit";
import BannerList from "./component/banner/Banner";
import BannerAdd from "./component/banner/BannerAdd";
import BannerEdit from "./component/banner/BannerEdit";
import HeaderImages from "./component/header/Header";
import HeaderEdit from "./component/header/HeaderEdit";
import EtikAdd from "./component/etik/EtikAdd";
import Etik from "./component/etik/Etik";
import EtikEdit from "./component/etik/EtikEdit";

function App() {
    return (
        <Router basepath="/fe-website">
            <div className="app-content">
                <Routes>
                    <Route
                        path="/"
                        element={
                            <PublicRoute>
                                <Login />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <Home />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/user"
                        element={
                            <ProtectedRoute>
                                <User />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/userAdd"
                        element={
                            <ProtectedRoute>
                                <UserAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/userEdit/:id_admin"
                        element={
                            <ProtectedRoute>
                                <UserEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/blog"
                        element={
                            <ProtectedRoute>
                                <Blog />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/blogAdd"
                        element={
                            <ProtectedRoute>
                                <BlogAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/blogEdit/:id_blog"
                        element={
                            <ProtectedRoute>
                                <BlogEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/blog_group"
                        element={
                            <ProtectedRoute>
                                <BlogGroup />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/blog_groupAdd"
                        element={
                            <ProtectedRoute>
                                <BlogGroupAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/blog_groupEdit/:id_blog_group"
                        element={
                            <ProtectedRoute>
                                <BlogGroupEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/faq"
                        element={
                            <ProtectedRoute>
                                <Faq />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/faqAdd"
                        element={
                            <ProtectedRoute>
                                <FaqAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/faqEdit/:id_faq"
                        element={
                            <ProtectedRoute>
                                <FaqEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/program"
                        element={
                            <ProtectedRoute>
                                <Program />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/programAdd"
                        element={
                            <ProtectedRoute>
                                <ProgramAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/programEdit/:id_program"
                        element={
                            <ProtectedRoute>
                                <ProgramEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/programGroup"
                        element={
                            <ProtectedRoute>
                                <ProgramGroup />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/programGroupAdd"
                        element={
                            <ProtectedRoute>
                                <ProgramGroupAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/programGroupEdit/:id"
                        element={
                            <ProtectedRoute>
                                <ProgramGroupEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/sekilas-perusahaan"
                        element={
                            <ProtectedRoute>
                                <InfoCompany />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/sekilas-perusahaanAdd"
                        element={
                            <ProtectedRoute>
                                <InfoCompanyAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/sekilas-perusahaanEdit/:id"
                        element={
                            <ProtectedRoute>
                                <InfoCompanyEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/struktur"
                        element={
                            <ProtectedRoute>
                                <Struktur />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/strukturAdd"
                        element={
                            <ProtectedRoute>
                                <StrukturAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/strukturEdit/:id_struktur"
                        element={
                            <ProtectedRoute>
                                <StrukturEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/jejak"
                        element={
                            <ProtectedRoute>
                                <Jejak />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/jejakAdd"
                        element={
                            <ProtectedRoute>
                                <JejakAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/jejakEdit/:id_jejak"
                        element={
                            <ProtectedRoute>
                                <JejakEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/galeri"
                        element={
                            <ProtectedRoute>
                                <Galeri />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/galeriAdd"
                        element={
                            <ProtectedRoute>
                                <GaleriAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/galeriEdit/:id_galeri"
                        element={
                            <ProtectedRoute>
                                <GaleriEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/galeri_group"
                        element={
                            <ProtectedRoute>
                                <GaleriGroup />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/galeri_groupAdd"
                        element={
                            <ProtectedRoute>
                                <GaleriGroupAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/galeri_groupEdit/:id_group"
                        element={
                            <ProtectedRoute>
                                <GaleriGroupEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/recruit"
                        element={
                            <ProtectedRoute>
                                <Recruit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/recruitAdd"
                        element={
                            <ProtectedRoute>
                                <RecruitAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/recruitEdit/:id_recruit"
                        element={
                            <ProtectedRoute>
                                <RecruitEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/career"
                        element={
                            <ProtectedRoute>
                                <Berkarir />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/careerAdd"
                        element={
                            <ProtectedRoute>
                                <BerkarirAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/careerEdit/:id_berkarir"
                        element={
                            <ProtectedRoute>
                                <BerkarirEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/entitas"
                        element={
                            <ProtectedRoute>
                                <Entitas />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/entitasAdd"
                        element={
                            <ProtectedRoute>
                                <EntitasAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/entitasEdit/:id_entitas"
                        element={
                            <ProtectedRoute>
                                <EntitasEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/pelaporan"
                        element={
                            <ProtectedRoute>
                                <Pelaporan />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/pelaporanAdd"
                        element={
                            <ProtectedRoute>
                                <PelaporanAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/pelaporanEdit/:id"
                        element={
                            <ProtectedRoute>
                                <PelaporanEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/etik"
                        element={
                            <ProtectedRoute>
                                <Etik />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/kodeEtikAdd"
                        element={
                            <ProtectedRoute>
                                <EtikAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/kodeEtikEdit/:id"
                        element={
                            <ProtectedRoute>
                                <EtikEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/dcare"
                        element={
                            <ProtectedRoute>
                                <Dcare />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/dcareAdd"
                        element={
                            <ProtectedRoute>
                                <DcareAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/dcareEdit/:id"
                        element={
                            <ProtectedRoute>
                                <DcareEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/utschool"
                        element={
                            <ProtectedRoute>
                                <Utschool />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/utschoolAdd"
                        element={
                            <ProtectedRoute>
                                <UtschoolAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/utschoolEdit/:id"
                        element={
                            <ProtectedRoute>
                                <UtschoolEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/poliklinik"
                        element={
                            <ProtectedRoute>
                                <Poliklinik />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/poliklinikAdd"
                        element={
                            <ProtectedRoute>
                                <PoliklinikAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/poliklinikEdit/:id"
                        element={
                            <ProtectedRoute>
                                <PoliklinikEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/kontak"
                        element={
                            <ProtectedRoute>
                                <Kontak />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/kontakAdd"
                        element={
                            <ProtectedRoute>
                                <KontakAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/kontakEdit/:id"
                        element={
                            <ProtectedRoute>
                                <KontakEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/banner"
                        element={
                            <ProtectedRoute>
                                <BannerList />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/bannerAdd"
                        element={
                            <ProtectedRoute>
                                <BannerAdd />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/bannerEdit/:id_banner"
                        element={
                            <ProtectedRoute>
                                <BannerEdit />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/header-images"
                        element={
                            <ProtectedRoute>
                                <HeaderImages />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/header/edit/:id"
                        element={
                            <ProtectedRoute>
                                <HeaderEdit />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
